<template>
  <div>
    <header class="lib__form__main__header">
      <h2 class="lib__h2">{{$t('e-mobility.car-specification-step.carTypeLabel')}}</h2>
    </header>
  
  <ValidationProvider rules="required" slim v-slot="state">
    <div :class="validationState(state)" class="lib__field">
      <div class="lib__tiles">
        <TileRadio item="electric" :label="$t('e-mobility.car-specification-step.carType.electric')" data-cy="tile-electric-car" group="vehicleType" v-model="carType"></TileRadio>
        <TileRadio item="hybrid" :label="$t('e-mobility.car-specification-step.carType.hybrid')" data-cy="tile-hybrid-car" group="vehicleType" v-model="carType"></TileRadio>
      </div>
      <error-message :error="state.errors[0]"></error-message>
    </div>
  </ValidationProvider>
  </div>
</template>

<script lang="ts">
import { CarType } from '@/models'
import { Component, Emit, Prop } from 'vue-property-decorator'
import FieldBox from '../../Shared/FieldBox'

@Component({
  name: 'car-type-selector'
})
export default class CarTypeSelector extends FieldBox {
  //#region [Property]
  @Prop({ type: String, required: false, default: '' }) public readonly value!: CarType
  //#endregion

  //#region [Computed]
  public get carType(): string | null {
    return this.value
  }
  public set carType(value: string | null) {
    this.change(value)
  }
  //#endregion

  //#region [Emit]
  @Emit('input')
  public change(value: string | null): string | null {
    return value
  }
  //#endregion
}
</script>